module.exports = __webpack_public_path__ + "img/ensolarado-nuvem.496b094b.png";